import { Text } from "@chakra-ui/react";
import { t } from "i18next";
import { RoundedFooterBanner } from "../../../../components/banners/RoundedFooterBanner";
import { useReleaseData } from "../../hooks/hookstate/useReleaseData";
import { FunnelContextArea, EventContextArea } from "../../../../components/funnel/types";
import { useMobileBreakpoint } from "../../../../utils/useBreakpoints";
import { useBuyPreviewContext } from "../../hooks/useBuyPreviewContext";
import { ReleasePricingActions } from "../../../../components/cards/ReleasePricingActions";
import { Release } from "../../../../types";
import { Z_INDEX_READER_BANNER } from "../../../root/constants";

export interface BuyPreviewFooterBannerProps {
  onDismiss?: () => void;
  isDismissed?: boolean;
}

export function BuyPreviewFooterBanner({
  onDismiss,
  isDismissed,
}: BuyPreviewFooterBannerProps) {
  const { releaseData } = useReleaseData();
  const isMobile = useMobileBreakpoint();
  const openPurchaseFunnel = useBuyPreviewContext(releaseData as Release);

  const { release_user_purchase, premium_only } = releaseData ?? {};

  if (!releaseData || release_user_purchase || releaseData.page_objects?.every(x => !x.display_paid_access_block) || !premium_only) {
    return null;
  }

  return (
    <RoundedFooterBanner
      containerProps={{
        mx: isMobile ? undefined : "52px",
        zIndex: Z_INDEX_READER_BANNER,
        pointerEvents: "auto",
        cursor: "pointer",
      }}
      text={
        <Text
          fontWeight="bold"
          fontSize="16px"
          lineHeight="130%"
          fontFamily="Bricolage Grotesque"
          color="dune.dune"
        >
          {t(
            "screens.reader.buyPreviewFooterBanner.youAreReadingAFreePreview",
            {
              releaseTitle: `${releaseData?.comic?.name}: ${releaseData?.title} `,
              interpolation: { escapeValue: false },
            },
          )}
        </Text>
      }
      onDismiss={onDismiss}
      isDismissed={isDismissed}
      actions={
        openPurchaseFunnel && (
          <ReleasePricingActions
            setFunnelConfig={openPurchaseFunnel}
            contextArea={FunnelContextArea.readerPreviewBanner}
            eventContextArea={EventContextArea.previewBanner}
            labelFontSize="14px"
            release={releaseData as Release}
            displayAsARow={!isMobile}
            onlyShowALCActions
            hidePreviewAction
            buttonSize="sm"
            contextualButtonDirection="top-end"
          />
        )
      }
    />
  );
}
